import { Fragment } from 'react';
import { Header, Text, VStack } from '@direct-frontend/components';
import { useFormContext } from '@adv-frontend/form-kit';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- Проблема в текущем файле, тк OrderForm должен быть в widgets
import { OrderProduct } from '@/features/OrderProduct';
import { type OrderDto, type OrderProductVariant } from '@/shared/api/order';
import { getProductImage } from '@/shared/lib/getProductImage';
import { makeModifierClassname } from '@/shared/lib/makeModifierClassname';
import { ORDER_FORM_ID } from '../../constants';
import { reinitializeOrderForm } from '../../lib/reinitializeOrderForm';
import { orderForm } from '../../model/forms/orderForm';
import { ChunkIntervalInput } from '../ChunkIntervalInput/ChunkIntervalInput';
import styles from './OrderDeliveryChunk.module.css';

interface OrderDeliveryChunkProps {
    title?: string;
    caption?: string;
    chunkId: number;
    items: OrderProductVariant[];
    shouldShowChunkIntervalInput: boolean;
    isDisabled?: boolean;
    openRegistrationOzon: VoidFunction;
}

const productsModifier = makeModifierClassname(styles, 'products');

export const OrderDeliveryChunk = (props: OrderDeliveryChunkProps) => {
    const { title, chunkId, items, caption, shouldShowChunkIntervalInput, isDisabled, openRegistrationOzon } = props;

    const { order } = useFormContext({ form: orderForm, id: ORDER_FORM_ID });

    return (
        <VStack gap="20">
            <VStack gap="8">
                <Header level="h3">{title}</Header>

                {caption && <Text size="mc">{caption}</Text>}
            </VStack>

            {shouldShowChunkIntervalInput ? (
                <ChunkIntervalInput chunkId={chunkId} openRegistrationOzon={openRegistrationOzon} />
            ) : null}

            <VStack gap="20" className={productsModifier('disabled', isDisabled)}>
                {items.map((item, index) => (
                    <Fragment key={`${item.product_variant_id}-${chunkId}`}>
                        <OrderProduct
                            name={item.name}
                            image={getProductImage(item.media[0])}
                            quantity={item.quantity}
                            maxQuantity={item.available_stock}
                            price={item.price}
                            finalPrice={item.final_price}
                            url={item.link_url}
                            canRemoved={items.length > 1}
                            characteristics={item.picker_characteristics}
                            chunkId={chunkId}
                            variantId={item.product_variant_id}
                            reinitialize={(updatedOrder: OrderDto) => reinitializeOrderForm(order, updatedOrder)}
                        />

                        {index < items.length - 1 ? <div className={styles.divider} /> : null}
                    </Fragment>
                ))}
            </VStack>
        </VStack>
    );
};
